import isApiError from "@insite/client-framework/Common/isApiError";
import { ServiceResult, get, post } from "@insite/client-framework/Services/ApiService";

const serviceUri = "/api/v1/uploadmkt";
const serviceUri1 = "/api/v1/removeallmkt";
const exportdataserviceUri = "/api/v1/downloadmktfile";
const exportdataserviceGetfileUri = "api/v1/export/GetFile";

export interface ProductsMktCollectionModel {
    ADIPartNo: string;
    StartDate: Date;
    EndDate: Date;
    SaleTypeIndicator: string;
}

// export interface ResultRemoved {

// }

export const uploadMktFile = async (productsMktObj: ProductsMktCollectionModel[]): Promise<ServiceResult<boolean>> => {
    try {
        const resultModel = await post<any>(`${serviceUri}`, productsMktObj);
        return {
            result: resultModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
};

export const removeAllMktFile = async (removeResult: boolean): Promise<ServiceResult<boolean>> => {
    try {
        const resultModel = await post<boolean>(`${serviceUri1}`, removeResult);
        return {
            result: resultModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
};

export const downloadMKTFileName = async () => {
    // const uri = `${exportdataserviceUri  }?parameter=` + `hi`;
    const uri = `${exportdataserviceUri}?parameter=hi`;
    try {
        const resultModel = await get<boolean>(`${uri}`);
        return {
            result: resultModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
};

export const downloadMKTFileExcel = async (fileName: string) => {
    // const uri = `${exportdataserviceUri  }?parameter=` + `hi`;
    const uri = `${exportdataserviceGetfileUri}?file=${fileName}`;
    try {
        const resultModel = await get<string>(`${uri}`);
        return {
            result: resultModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
};
